export default __webpack_public_path__ + "static/media/voice-call-credits-rocket.6ee5fb0a.png";